export const deliverabilityEmailAppGroupIdData = "/deliverability/email/:app_group_id/data";
